<template>
  <el-dialog
    v-dialogDrag
    class="mini-dialog"
    :append-to-body="true"
    :visible.sync="visible"
    title="销号"
  >
    <el-form :model="form" ref="form" label-width="150px">
      <el-form-item label="销号备注" prop="remark">
        <el-input
          placeholder="请输入销号备注"
          maxlength="500"
          show-word-limit
          type="textarea"
          rows="3"
          v-model="form.remark"
          clearable
        ></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer flex justify-center items-center">
      <el-button
        :loading="loading"
        size="small"
        type="primary"
        class="iconfont icon-save"
        @click="save()"
        >保存</el-button
      >
      <el-button size="small" class="iconfont icon-close" @click="visible = false">取消</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'cancel-dialog',
  props: {},
  components: {},
  watch: {
    visible(val) {
      if (!val) {
        this.$emit('cancel')
      }
    },
  },
  data() {
    return {
      visible: true,
      form: {
        remark: '',
      },
      loading: false,
    }
  },
  computed: {},
  methods: {
    async save() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          this.$emit('handleOk', this.form.remark)
        }
      })
    },
  },
  created() {},
}
</script>

<style scoped lang="scss"></style>
